var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import objectTrait from "../Decorators/objectTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import CatalogMemberTraits from "./CatalogMemberTraits";
import LegendOwnerTraits from "./LegendOwnerTraits";
import MappableTraits from "./MappableTraits";
import SplitterTraits from "./SplitterTraits";
import StyleTraits from "./StyleTraits";
import UrlTraits from "./UrlTraits";
let SenapsLocationsCatalogItemTraits = (_dec = primitiveTrait({
  type: "string",
  name: "Location ID Filter",
  description: "\n    A string to filter locations using the id field, locations matching the filter will be included,\n    multiple filters can be seperated using a comma, eg \"*boorowa*,*environdata*\"\n    "
}), _dec2 = primitiveTrait({
  type: "string",
  name: "Stream ID Filter",
  description: "\n    A string to filter streams using the id field, streams matching the filter will be included,\n    multiple filters can be seperated using a comma, eg \"*SHT31DIS_ALL*,*environdata*\"\n    "
}), _dec3 = objectTrait({
  type: StyleTraits,
  name: "Style",
  description: "Styling rules that follow [simplestyle-spec](https://github.com/mapbox/simplestyle-spec)"
}), _class = class SenapsLocationsCatalogItemTraits extends mixTraits(SplitterTraits, MappableTraits, CatalogMemberTraits, LegendOwnerTraits, UrlTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "locationIdFilter", _descriptor, this);
    _initializerDefineProperty(this, "streamIdFilter", _descriptor2, this);
    _initializerDefineProperty(this, "style", _descriptor3, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "locationIdFilter", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "streamIdFilter", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "style", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { SenapsLocationsCatalogItemTraits as default };